export const serviceList = [
  {
    image: "1",
    title: "Conception Web & Branding",
    description:
      "Une grande marque combine design et messagerie pour susciter l’émotion chez vos clients et conduire la stratégie.",
    title2: "Développement Web Sur Mesure",
    title3: "Nos Services Web:",
    title4: "Nous sommes prêts à répondre à vos besoins.",
    undertitle1: "Site web vitrine",
    undertitle2: "Site web dynamique",
    undertitle3: "Site E-commerce",
    undertitle4: "Refonte Site Web",
    undertitle5: "Maintenance Site Web",
    undertitle6: "Community Managment",
    undertitle7: "",
    undertitle8: "",
    undertitle9: "",
    paragraph1:"RIATICA œuvre pour vous créer un site web vitrine attrayant qui reflète les valeurs de votre entreprise..",
    paragraph2:"RIATICA mobilise son expertise et son savoir-faire pour vous offrir un site web dynamique adapté aux besoins de votre entreprise.",
    paragraph3:"Boostez le chiffre d'affaires de votre Business grâce à un site e-commerce séduisant réalisé par RIATICA.",
    paragraph4:"Notre équipe d'experts en refonte de site web s'engage à améliorer votre vieux site afin de lui donner un nouvel élan.",
    paragraph5:"Pour une pérennité de votre site web, profitez des solutions de Maintenance clés en main de RIATICA.",
    paragraph6:"Experte en Community Management, RIATICA vous accompagne dans la mise en place d’une stratégie webmarketing sur les réseaux sociaux à la fois efficace et unique.",
    paragraph7:"",
    paragraph8:"",
    paragraph9:"Votre site doit bien-sûr être agréable à regarder, mais pas seulement. Il doit être convivial, simple d'utilisation et surtout séduire votre public grâce à un graphisme ciblé et des fonctionnalités bien pensées.",

    image2: "service1.png",
    description2:
      "Les solutions proposées sont de ce fait étudiées pour s’accorder avec les contraintes financières et marketing. Notre objectif est de garantir une parfaite compatibilité des options mises à votre disposition avec la nature de vos activités. Les fonctionnalités, le paramétrage, l’évolutivité, tout cela fait partie de nos principales préoccupations. Notre agence s’est promise de vous épauler et de vous assister pas à pas vers la création ultime de votre site web. Préfériez-vous un site d’exposition de produits ou de services ? Un site dédié à l’apprentissage en ligne ? Une plateforme de business numérique ? Ou tout simplement un espace convivial et propice à un forum à haut trafic ? Ne cherchez pas plus loin que notre équipe, ne gâchez plus votre énergie, on est les spécialistes du développement Web sur mesure les plus pérennes et de développement application web sur mesure.",
  },
  {
    image: "2",
    title: "Conception Graphique",
    description:
      "Une expérience riche et une imagination illimitée est ce qui nous fait nous démarquer des autres.",
    title2: "Fournir des services de conception graphique efficaces aux clients",
    title3: "Nos sercices graphiques sont :",
    title4: "Nous sommes prêts à répondre à vos besoins.    ",
    undertitle1: "Création de logo",
    undertitle2: "Création d'affiche",
    undertitle3: "Création de dépliant",
    undertitle4: "Création de plaquette commerciale",
    undertitle5: "Création de flyer",
    undertitle6: "Création de chemise à rabats",
    undertitle7: "Création de carte de visite",
    undertitle8: "",
    undertitle9: "",
    paragraph1:"Transmettre une forte image de marque",
    paragraph2:"Renforcez votre message publicitaire",
    paragraph3:"Présentez vos produits et vos services",
    paragraph4:"Présentez votre activité et vos services",
    paragraph5:"Un document incontournable de votre communication",
    paragraph6:"Profitez d'une support de communication pratique",
    paragraph7:"Optez pour une carte originale et élégante",
    paragraph8:"",
    paragraph9:"Nous aidons nos clients à prospérer dans une période de bruit et de distraction en créant des expériences de marque, d'impression et Web convaincantes qui obligent les gens à agir. Nous soutenons leur mission et aidons à raconter leur histoire à travers la stratégie et la créativité.",

    image2: "service2.jpg",
    description2: "Nous créons des graphiques professionnels, esthétiquement beaux et de hautes qualités pour les petites et moyennes entreprises, avec des solutions économiques en argent & en temps, en plus d’une expérience hautement personnalisée pour nos clients de la région du Grand Moncton et d'ailleurs.",
  },
  {
    image: "3",
    title: "Production Video",
    description:
      "La création et l'édition de vidéos professionnelles sont notre point fort. Pour une bonne stratégie numérique.",
      title2: "Production de vidéos corporatives et publicitaires",
      title3: "",
      undertitle1: "Production de vidéos corporatives et publicitaires",
      undertitle2: "Vidéo corporative",
      undertitle3: "Vidéo artistique",
      undertitle4: "Vidéo promotionnelle",
      undertitle5: "Publicité télévisuelle",
      undertitle6: "",
      undertitle7: "",
      undertitle8: "",
      undertitle9: "",
      paragraph1:"Augmentez l’impact de vos communications par la force de la webdiffusion. Nous avons la solution pour la gestion et la production de votre webdiffusion ou de votre webinaire. Informez-vous!",
      paragraph2:"Nous savons à quel point l’image de votre entreprise est importante. Nous avons les idées et l’expertise pour réaliser la vidéo qui fera la différence.",
      paragraph3:"Que ce soit un vidéo-clip ou une vidéo de spectacle, faites confiance à notre équipe. Plusieurs artistes de tous les milieux font affaire avec IDEO. Nous sommes originaux et passionnés, tout comme vous.",
      paragraph4:"Que ce soit pour la conception, la production ou la post-production, notre équipe a l’expertise qui fera la différence.",
      paragraph5:"Nous avons réalisé plusieurs publicités télévisuelles pour Radio-Canada, Vtélé, TVA, etc. Nous nous démarquons par l’originalité, la qualité visuelle et nos prix!",
      paragraph6:"",
      paragraph7:"",
      paragraph8:"",
      paragraph9:"",
  
      image2: "service3.jpg",
      description2: "Vous voulez être certain que votre message sera transmis efficacement, qu’il touchera sa cible? Pour vous en assurer, utilisez le média corporatif le plus complet et le plus flexible du monde numérique. En faisant appel à nos services de production vidéo, vos communications seront vues, entendues et comprises par tous vos publics cibles.",
  },
  {
    image: "4",
    title: "SEO",
    description:
      "Des stratégies étudiées pour rendre votre site web plus rapide et se classer dans les premières pages des moteurs de recherche.",
    title2: "Référencement web - Améliorez la visibilité de vos sites",
    title3: "Nos services de référencement:",
    undertitle1: "Référencement local",
    undertitle2: "Référencement international",
    undertitle3: "Le référencement boutique/e-commerce",
    undertitle4: "Audit SEO",
    undertitle5: "",
    undertitle6: "",
    undertitle7: "",
    undertitle8: "",
    undertitle9: "",
    paragraph1:"Le referencement local, stratégie SEO des commerces et entreprises de proximité. Les requêtes locales apportent souvent un trafic très qualifié et offre donc des opportunités de conversions plus importantes.",
    paragraph2:"Le référencement international désigne l’ensemble des actions d’optimisations de site visant à le rendre visible sur les moteurs de recherche dans plusieurs pays différents et/ou dans plusieurs langues différentes.",
    paragraph3:"Le référencement e-commerce d’un site est une tâche spécifique qui contient son lot de particularités.    ",
    paragraph4:"L’audit SEO est l’étape indispensable et préalable au déploiement d’une stratégie de référencement ciblée et efficace.",
    paragraph5:"",
    paragraph6:"",
    paragraph7:"",
    paragraph8:"",
    paragraph9:"",

    image2: "service4.jpg",
    description2: "Le SEO ou Search Engine Optimization permet de bien positionner ses pages ou sites sur les moteurs de recherche, et évidemment plus spécifiquement sur Google.",
  },
  {
    image: "5",
    title: "Digital Marketing",
    description:
      "Avec le marketing numérique, votre entreprise peut se développer et réaliser d’énormes chiffres.",
    title2: "Accélérez votre croissance grâce au marketing sur Internet    ",
    title3: "Nos services de Marketing Digital :",
    undertitle1: "Référencement Naturel    ",
    undertitle2: "Référencement Payant",
    undertitle3: "Social Media",
    undertitle4: "Email Marketing",
    undertitle5: "",
    undertitle6: "",
    undertitle7: "",
    undertitle8: "",
    undertitle9: "",
    paragraph1:"Le canal d’acquisition le plus rentable du web ! Grâce à une stratégie SEO efficace, vous attirez des visiteurs intéressés et améliorez le nombre de demandes provenant d’Internet.97% des expériences web commencent pas un moteur de recherche",
    paragraph2:"La mise en place de la publicité Google Ads positionne votre site dans les 1ères positions de Google sur les recherches à valeur commerciale dès le lendemain. Les 3 meilleurs annonces payantes captent 40% de tous les clics.",
    paragraph3:"Adapté à des objectifs de notoriété, les réseaux sociaux offre une large visibilité auprès d’un public sélectionné : âge, sexe, loisirs ou encore domiciliation.54% des adeptes des réseaux sociaux les utilisent pour rechercher des produits",
    paragraph4:"Mettez à profits vos bases de données clients et prospects en adressant des emails ciblés qui servent vos objectifs commerciaux et votre saisonnalité.Mettez à profits vos bases de données clients et prospects en adressant des emails ciblés qui servent vos objectifs commerciaux et votre saisonnalité.Le ROI moyen de l’email marketing s’élève à 3800%.",
    paragraph5:"",
    paragraph6:"",
    paragraph7:"",
    paragraph8:"",
    paragraph9:"",

    image2: "service5.jpg",
    description2: "Nous activons les leviers indispensables pour attirer des visiteurs qualifiés et les convertir sur votre site internet",
  },
  {
    image: "6",
    title: "Inforgraphie",
    description:
      "Transformez vos données en œuvres captivantes qui garderont votre public engagé.",
    title2: "",
    title3: "",
    undertitle1: "",
    undertitle2: "",
    undertitle3: "",
    undertitle4: "",
    undertitle5: "",
    undertitle6: "",
    undertitle7: "",
    undertitle8: "",
    undertitle9: "",
    paragraph1:"",
    paragraph2:"",
    paragraph3:"",
    paragraph4:"",
    paragraph5:"",
    paragraph6:"",
    paragraph7:"",
    paragraph8:"",
    paragraph9:"",

    image2: "service6.jpg",
    description2: "",
  },
  {
    image: "7",
    title: "Sécurité & Surveillance",
    description:
      "Spécialistes de l’installation de système de vidéosurveillance (caméras IP, sans fil, …).",
    title2: "Se sentir en sécurité n'importe ou",
    title3: "Nos Services:",
    undertitle1: "Conseil",
    undertitle2: "Installation",
    undertitle3: "Installation",
    undertitle4: "Formation",
    undertitle5: "Maintenance",
    undertitle6: "Dépannage",
    undertitle7: "",
    undertitle8: "",
    undertitle9: "",
    paragraph1:"Nos experts vous conseillent et déterminent la solution et le matériel les plus adaptés à vos besoins.",
    paragraph2:"Nos techniciens, dont des installateurs video surveillance, installent votre système de vidéosurveillance et mettent en service votre installation.",
    paragraph3:"Nos techniciens paramètrent votre système et installent sur votre PC et smartphone les logiciels.",
    paragraph4:"Nous formons vos équipes et vous expliquons le fonctionnement de votre système pour en tirer le meilleur profit.",
    paragraph5:"Nous assurons la maintenance et veillons au bon fonctionnement de votre système dans la durée.",
    paragraph6:"Au moindre problème, notre équipe intervient et vous dépanne dans les plus brefs délais.",
    paragraph7:"",
    paragraph8:"",
    paragraph9:"",

    image2: "service7.jpg",
    description2: "Grâce aux caméras de surveillance, vous conservez un œil attentif sur votre patrimoine à tout instant : Bureaux, usines, Locaux, ateliers, maisons,... Recherche d’images, arrêt sur image, zoom, vous disposez de toutes les fonctionnalités et avantages de la surveillance vidéo.",
  },
  {
    image: "8",
    title: "Infrastructure Réseaux",
    description:
      "Spécialisée dans l'installation des réseaux informatique en Tunisie.",
    title2: "",
    title3: "",
    undertitle1: "",
    undertitle2: "",
    undertitle3: "",
    undertitle4: "",
    undertitle5: "",
    undertitle6: "",
    undertitle7: "",
    undertitle8: "",
    undertitle9: "",
    paragraph1:"",
    paragraph2:"",
    paragraph3:"",
    paragraph4:"",
    paragraph5:"",
    paragraph6:"",
    paragraph7:"",
    paragraph8:"",
    paragraph9:"",

    image2: "service8.jpg",
    description2: "",
  },
  {
    image: "9",
    title: "Audit & Consulting",
    description:
      "Protection en évaluant le niveau de sécurité de vos systèmes d'information.",
    title2: "Services d'audit de sécurité et scan de vulnérabilité dédiés à la stabilité de votre SI",
    title3: "Nos services :",
    undertitle1: "Gouvernance de la sécurité",
    undertitle2: "Audit d’architecture",
    undertitle3: "Test d’intrusion externe / interne",
    undertitle4: "Solutions de remédiation",
    undertitle5: "",
    undertitle6: "",
    undertitle7: "",
    undertitle8: "",
    undertitle9: "",
    paragraph1:"Nous vous aidons à construire un cadre spécifique d’analyse et une structure organisationnelle appropriée, vous assurant une prise de décision optimale, afin de faire évoluer votre SI en accord avec les besoins de vos clients, fournisseurs, partenaires et collaborateurs.",
    paragraph2:"Nous réalisons des audits qui s’appuient sur une étude documentaire, des entretiens et une analyse de configuration informatique.Nous évaluons ainsi la sécurité globale de votre infrastructure afin d’établir votre plan de remédiation.",
    paragraph3:"Nous mesurons la vulnérabilité de l’infrastructure, du réseau et des applicatifs par des simulations d’attaques externes et internes à votre SI. Vous aurez ainsi une vision claire du niveau de sécurité de votre infrastructure et des solutions de remédiations qui s’offrent à vous.",
    paragraph4:"Nous instaurons un comité de suivi pour assurer la mise en conformité de votre système d’information, pour mieux vous accompagner dans le choix et la mise en œuvre des solutions techniques ou organisationnelles devant garantir la sécurité de votre SI.",
    paragraph5:"",
    paragraph6:"",
    paragraph7:"",
    paragraph8:"",
    paragraph9:"",

    image2: "service9.jpg",
    description2: "RIATICA propose 4 prestations pour sécuriser étape par étape l’intégralité de votre SI et vous transmet les bonnes pratiques nécessaires pour accompagner son évolution.",
  },
];
